<template>
    <v-form @submit.prevent="addUpdate" ref="form">
        <v-card class="rounded-4">
            <v-toolbar flat height="55px">
                <span class="font-weight-bold">Add Other Recipients</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="form-container">
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-row">
                        <div class="caption grey--text text--darken-2 mt-0 mr-30">
                            Select employees or HR staff who should receive notifications
                        </div>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="form-row">
                        <v-autocomplete
                            v-model="selectedUsers"
                            :disabled="disabled"
                            :items="employees"
                            :loading="loading_employees"
                            :rules="[rules.required]"
                            chips
                            multiple
                            color="primary lighten-2"
                            label=" Select employees"
                            item-text="name"
                            item-value="userId"
                            >
                            <template v-slot:selection="data">
                                <v-chip :selected="data.selected" class="chip--select-multi">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="data.item.avatar"></v-img>
                                    </v-avatar>
                                    {{ data.item.name }}
                                </v-chip>
                            </template>
                            <template v-slot:item="data">
                                <template v-if="typeof data.item !== 'object'">
                                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                                </template>
                                <template v-else>
                                <v-list-tile-avatar>
                                    <img :src="data.item.avatar">
                                </v-list-tile-avatar>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="data.item.group"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                </template>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :disabled="disabled||!selectedUsers.length" :loading="loading" class="mr-25">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import employeeApi from '@/api/employees'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    data () {
        return {
            loading: false,
            disabled: false,
            rules: {
                required: value => !!value || 'Required field.',
            }, 
            error: false,
            errorMessage: null,
            loading_employees: false,
            employees: [],
            employees_orig: [],
            existing_users: [],
            selectedUsers: []
        }
    },
    methods: {
        setData(data) {
            this.clearForm()
            this.existing_users = data

            if (!this.employees.length) {
                this.getEmployees()
            }
        },
        async getEmployees() {
            try {
                this.loading_employees = true
                this.employees = []
                const response = await employeeApi.getAll()
                if (response && response.status == 200) {
                    //deep clone
                    this.employees_orig = JSON.parse(JSON.stringify(response.data.employees)) 

                    //exclude those already exist
                    const filtered = response.data.employees.filter(user => {
                        return !this.existing_users.some(x => x.userId == user.userId) 
                    });

                    filtered.forEach(item => {
                        this.employees.push({
                            userId: item.userId,
                            name: item.firstName + " " + item.lastName,
                            avatar: awsS3Helper.getAvatarUrl(item.userId),
                        })
                    })
                }
                this.loading_employees = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        async addUpdate() {
            if (this.$refs.form.validate()) {
                const selectedData = this.employees_orig.filter(user => this.selectedUsers.includes(user.userId))
                this.$emit('send', selectedData)
                this.closeDialog()
            }
        },
        closeDialog() {
            this.$emit('update:dialogAddOtherRecipients', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
    },
}
</script>
<style scoped>
.form-container {
    padding:10px 20px 0px 20px;
}
.form-row {
    padding: 0px 15px 0px 15px;
}
</style>